import React, { useState, useEffect } from 'react';
import api from '../api/Api';
import { 
  Briefcase,
  X,
  ExternalLink,
  Calendar,
  Tag,
  CheckCircle2,
  Award,
  TrendingUp,
  Building2,
  Code,
  Globe,
  Shield,
  Network,
  FileCode,
  Server,
  ShoppingCart,
  Utensils,
  GraduationCap,
  Heart
} from 'lucide-react';
import Header from "../Header";
import Footer from "../Footer";
import QuoteModal from '../ModalOrcamento';


export default function PortfolioPage({ isDarkMode, setIsDarkMode }) {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedProject, setSelectedProject] = useState(null);
    const URL_BASE ='https://api.angonet.ao/public/img/projectos/';
 // const URL_BASE = 'http://127.0.0.1:8000/storage/img/projectos/';
  const [projects, setProjects] = useState([]);
const [loading, setLoading] = useState(true);
    const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);
const [preSelectedService, setPreSelectedService] = useState(null);

 
  const categories = [
    { id: 'all', name: 'Todos os Projetos', icon: Briefcase },
    { id: 'software', name: 'Software', icon: Code },
    { id: 'websites', name: 'Websites', icon: Globe },
    { id: 'security', name: 'Segurança', icon: Shield },
    { id: 'infrastructure', name: 'Infraestrutura', icon: Network }
  ];

const filteredProjects = selectedCategory === 'all' 
  ? projects 
  : projects.filter(p => p.category === selectedCategory);


  const featuredProjects = projects.filter(p => p.featured);

  const getCategoryColor = (category) => {
    const colors = {
      software: 'from-blue-500 to-cyan-500',
      websites: 'from-cyan-500 to-blue-600',
      security: 'from-purple-600 to-violet-600',
      infrastructure: 'from-blue-600 to-purple-600'
    };
    return colors[category] || 'from-gray-500 to-gray-600';
  };

useEffect(() => {
  document.title = "Projectos";
  fetchProjects();
}, []);



const fetchProjects = async () => {
  setLoading(true);

  try {
    const response = await api.ListProjecto();
    const dados = Array.isArray(response) ? response : [];

    const formatado = dados.map(item => ({
      id: item.id,
      title: item.titulo,
      category: normalizeCategory(item.categoria),
      client: item.cliente,
      year: "", // ou item.ano se existir
      image: item.img 
        ? `${URL_BASE}${item.img}` 
        : "https://images.unsplash.com/photo-1492724441997-5dc865305da7?w=800&h=600&fit=crop",

      description: item.sobre,
      challenge: item.defafio,
      solution: item.solucao,

      results: item.resultado
        ? item.resultado.split(',')
        : [],

      technologies: item.tecnologia
        ? item.tecnologia.split(',')
        : [],

      featured: true // pode ajustar depois se tiver campo no banco
    }));

    setProjects(formatado);

  } catch (error) {
    console.error("Erro ao carregar projetos:", error);
  } finally {
    setLoading(false);
  }
};


const normalizeCategory = (categoria) => {
  const map = {
    'Software': 'software',
    'Website': 'websites',
    'Segurança': 'security',
    'Infraestrutura': 'infrastructure'
  };

  return map[categoria] || 'software';
};





  const getCategoryIcon = (category) => {
    const icons = {
      software: Code,
      websites: Globe,
      security: Shield,
      infrastructure: Network
    };
    return icons[category] || Briefcase;
  };


  if (loading) {
  return (
    <div className={`min-h-screen transition-colors duration-300 ${
      isDarkMode ? 'bg-gray-900 text-white' : 'bg-white text-gray-900'
    }`}>
      {/* Background igual ao resto da página */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className={`absolute top-0 right-0 w-[800px] h-[800px] rounded-full blur-[120px] animate-pulse ${
          isDarkMode ? 'bg-blue-500/10' : 'bg-blue-400/20'
        }`}></div>
        <div className={`absolute bottom-0 left-0 w-[600px] h-[600px] rounded-full blur-[120px] animate-pulse ${
          isDarkMode ? 'bg-purple-500/10' : 'bg-purple-500/20'
        }`}></div>
      </div>

      <Header isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />

      <div className="flex flex-col items-center justify-center py-40 relative z-10">
        <div className="animate-spin rounded-full h-14 w-14 border-b-2 border-blue-600 mb-6"></div>
        
        <p className={`text-lg font-medium ${
          isDarkMode ? 'text-gray-400' : 'text-gray-600'
        }`}>
          Carregando Projectos...
        </p>
      </div>

      <Footer isDarkMode={isDarkMode} />
    </div>
  );
}

 

  return (
    <div className={`min-h-screen transition-colors duration-300 ${
      isDarkMode ? 'bg-gray-900 text-white' : 'bg-white text-gray-900'
    }`}>
      {/* Animated Background Particles */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className={`absolute top-0 right-0 w-[800px] h-[800px] rounded-full blur-[120px] animate-pulse ${
          isDarkMode ? 'bg-blue-500/10' : 'bg-blue-400/20'
        }`}></div>
        <div className={`absolute bottom-0 left-0 w-[600px] h-[600px] rounded-full blur-[120px] animate-pulse ${
          isDarkMode ? 'bg-purple-500/10' : 'bg-purple-500/20'
        }`} style={{animationDelay: '1s'}}></div>
        <div className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] rounded-full blur-[100px] animate-pulse ${
          isDarkMode ? 'bg-cyan-500/5' : 'bg-cyan-400/15'
        }`} style={{animationDelay: '2s'}}></div>
        
        {/* Floating particles */}
        <div className="absolute top-[20%] left-[15%] w-1 h-1 bg-blue-500 rounded-full animate-float"></div>
        <div className="absolute top-[40%] right-[20%] w-1.5 h-1.5 bg-cyan-500 rounded-full animate-float" style={{animationDelay: '1s'}}></div>
        <div className="absolute top-[60%] left-[30%] w-1 h-1 bg-purple-500 rounded-full animate-float" style={{animationDelay: '2s'}}></div>
        <div className="absolute top-[80%] right-[40%] w-2 h-2 bg-blue-400 rounded-full animate-float" style={{animationDelay: '0.5s'}}></div>
        <div className="absolute top-[30%] right-[10%] w-1 h-1 bg-cyan-400 rounded-full animate-float" style={{animationDelay: '1.5s'}}></div>
        <div className="absolute top-[70%] left-[50%] w-1.5 h-1.5 bg-purple-400 rounded-full animate-float" style={{animationDelay: '2.5s'}}></div>
      </div>

      <Header isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />

      {/* Hero Section */}
      <section className={`relative pt-32 pb-20 px-6 overflow-hidden ${
        isDarkMode ? 'bg-gray-800' : 'bg-gradient-to-br from-blue-50 to-purple-50'
      }`}>
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="text-center max-w-3xl mx-auto">
            <div className="inline-flex items-center space-x-2 px-4 py-2 bg-blue-500/10 border border-blue-500/30 rounded-full mb-6">
              <Award size={20} className="text-blue-600" />
              <span className={`text-sm font-semibold ${
                isDarkMode ? 'text-cyan-400' : 'text-blue-600'
              }`}>
                Casos de Sucesso
              </span>
            </div>

            <h1 className={`text-4xl md:text-6xl font-bold mb-6 ${
              isDarkMode ? 'text-white' : 'text-gray-900'
            }`}>
              Nossos <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">Projectos</span>
            </h1>
            <p className={`text-xl mb-8 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
              Conheça alguns dos projetos que transformaram negócios e impactaram positivamente nossos clientes
            </p>
          </div>
        </div>
      </section>

      {/* Category Filter */}
      <section className={`border-b ${
        isDarkMode ? 'bg-gray-800/50 border-white/10' : 'bg-white border-gray-200'
      }`}>
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((category) => {
              const Icon = category.icon;
              return (
                <button
                  key={category.id}
                  onClick={() => setSelectedCategory(category.id)}
                  className={`flex items-center space-x-2 px-6 py-3 rounded-full font-medium transition-all ${
                    selectedCategory === category.id
                      ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg scale-105'
                      : isDarkMode
                      ? 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  <Icon size={18} />
                  <span>{category.name}</span>
                </button>
              );
            })}
          </div>
        </div>
      </section>

      {/* Featured Projects */}
      {selectedCategory === 'all' && (
        <section className="py-16 px-6 relative z-10">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-8">
              <h2 className={`text-3xl md:text-4xl font-bold ${
                isDarkMode ? 'text-white' : 'text-gray-900'
              }`}>
                Projectos em Destaque
              </h2>
              <TrendingUp className={isDarkMode ? 'text-cyan-400' : 'text-blue-600'} size={32} />
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              {featuredProjects.slice(0, 4).map((project, index) => {
                const CategoryIcon = getCategoryIcon(project.category);
                return (
                  <div
                    key={project.id}
                    onClick={() => setSelectedProject(project)}
                    className={`group rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 ${
                      isDarkMode
                        ? 'bg-gray-800 border border-white/10 hover:border-cyan-500/50'
                        : 'bg-white border border-gray-200 hover:border-blue-500/50 shadow-lg hover:shadow-2xl'
                    }`}
                    style={{animationDelay: `${index * 0.1}s`}}
                  >
                    <div className="relative h-64 overflow-hidden">
                      <img
                        src={project.image}
                        alt={project.title}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                      <div className={`absolute top-4 left-4 px-3 py-1 rounded-full text-xs font-semibold bg-gradient-to-r ${getCategoryColor(project.category)} text-white flex items-center space-x-1`}>
                        <CategoryIcon size={14} />
                        <span>{project.category}</span>
                      </div>
                      <div className="absolute bottom-4 left-4 right-4">
                        <h3 className="text-white text-2xl font-bold mb-2">
                          {project.title}
                        </h3>
                        <div className="flex items-center text-white/80 text-sm space-x-4">
                          <span className="flex items-center">
                            <Building2 size={14} className="mr-1" />
                            {project.client}
                          </span>
                          <span className="flex items-center">
                            <Calendar size={14} className="mr-1" />
                            {project.year}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="p-6">
                      <p className={`text-sm mb-4 line-clamp-2 ${
                        isDarkMode ? 'text-gray-400' : 'text-gray-600'
                      }`}>
                        {project.description}
                      </p>

                      <button className={`flex items-center space-x-2 font-semibold transition-colors ${
                        isDarkMode ? 'text-cyan-400 hover:text-cyan-300' : 'text-blue-600 hover:text-blue-700'
                      }`}>
                        <span>Ver detalhes</span>
                        <ExternalLink size={16} className="group-hover:translate-x-1 transition-transform" />
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      )}

      {/* All Projects Grid */}
      <section className="py-16 px-6 relative z-10">
        <div className="max-w-7xl mx-auto">
          <h2 className={`text-3xl md:text-4xl font-bold mb-8 ${
            isDarkMode ? 'text-white' : 'text-gray-900'
          }`}>
            Todos os Projectos
          </h2>

          <div className="grid md:grid-cols-3 gap-6">
            {filteredProjects.map((project, index) => {
              const CategoryIcon = getCategoryIcon(project.category);
              return (
                <div
                  key={project.id}
                  onClick={() => setSelectedProject(project)}
                  className={`group rounded-xl overflow-hidden cursor-pointer transition-all duration-300 ${
                    isDarkMode
                      ? 'bg-gray-800 border border-white/10 hover:border-cyan-500/50'
                      : 'bg-white border border-gray-200 hover:border-blue-500/50 shadow-lg hover:shadow-2xl'
                  }`}
                  style={{animationDelay: `${index * 0.05}s`}}
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={project.image}
                      alt={project.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className={`absolute top-3 left-3 px-2 py-1 rounded-full text-xs font-semibold bg-gradient-to-r ${getCategoryColor(project.category)} text-white flex items-center space-x-1`}>
                      <CategoryIcon size={12} />
                      <span>{project.category}</span>
                    </div>
                  </div>

                  <div className="p-5">
                    <h3 className={`text-lg font-bold mb-2 line-clamp-1 ${
                      isDarkMode ? 'text-white group-hover:text-cyan-400' : 'text-gray-900 group-hover:text-blue-600'
                    } transition-colors`}>
                      {project.title}
                    </h3>

                    <p className={`text-xs mb-3 ${isDarkMode ? 'text-gray-500' : 'text-gray-500'}`}>
                      {project.client} • {project.year}
                    </p>

                    <p className={`text-sm line-clamp-2 ${
                      isDarkMode ? 'text-gray-400' : 'text-gray-600'
                    }`}>
                      {project.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Project Modal */}
      {selectedProject && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm"
             onClick={() => setSelectedProject(null)}>
          <div 
            className={`relative max-w-5xl w-full max-h-[90vh] overflow-y-auto rounded-2xl ${
              isDarkMode ? 'bg-gray-800' : 'bg-white'
            }`}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={() => setSelectedProject(null)}
              className={`absolute top-4 right-4 z-10 p-2 rounded-full transition-all ${
                isDarkMode ? 'bg-gray-700 hover:bg-gray-600 text-white' : 'bg-white hover:bg-gray-100 text-gray-900 shadow-lg'
              }`}
            >
              <X size={24} />
            </button>

            {/* Header Image */}
            <div className="relative h-96 overflow-hidden rounded-t-2xl">
              <img
                src={selectedProject.image}
                alt={selectedProject.title}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <div className={`inline-flex items-center space-x-2 px-3 py-1 rounded-full text-xs font-semibold bg-gradient-to-r ${getCategoryColor(selectedProject.category)} text-white mb-4`}>
                  {React.createElement(getCategoryIcon(selectedProject.category), { size: 14 })}
                  <span>{selectedProject.category}</span>
                </div>
                <h2 className="text-white text-3xl md:text-4xl font-bold mb-3">
                  {selectedProject.title}
                </h2>
                <div className="flex items-center text-white/90 text-sm space-x-4">
                  <span className="flex items-center">
                    <Building2 size={16} className="mr-2" />
                    {selectedProject.client}
                  </span>
                  <span className="flex items-center">
                    <Calendar size={16} className="mr-2" />
                    {selectedProject.year}
                  </span>
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="p-8">
              <div className="mb-8">
                <h3 className={`text-xl font-bold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                  Sobre o Projeto
                </h3>
                <p className={`text-lg leading-relaxed ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                  {selectedProject.description}
                </p>
              </div>

              <div className="grid md:grid-cols-2 gap-8 mb-8">
                <div>
                  <h3 className={`text-xl font-bold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                    Desafio
                  </h3>
                  <p className={`leading-relaxed ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                    {selectedProject.challenge}
                  </p>
                </div>

                <div>
                  <h3 className={`text-xl font-bold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                    Solução
                  </h3>
                  <p className={`leading-relaxed ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                    {selectedProject.solution}
                  </p>
                </div>
              </div>

              <div className="mb-8">
                <h3 className={`text-xl font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                  Resultados Alcançados
                </h3>
                <div className="grid md:grid-cols-2 gap-4">
                  {selectedProject.results.map((result, index) => (
                    <div key={index} className="flex items-start space-x-3">
                      <CheckCircle2 size={20} className="text-green-500 flex-shrink-0 mt-1" />
                      <span className={isDarkMode ? 'text-gray-400' : 'text-gray-600'}>
                        {result}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <h3 className={`text-xl font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                  Tecnologias Utilizadas
                </h3>
                <div className="flex flex-wrap gap-3">
                  {selectedProject.technologies.map((tech, index) => (
                    <span
                      key={index}
                      className={`px-4 py-2 rounded-full text-sm font-medium ${
                        isDarkMode
                          ? 'bg-gray-700 text-cyan-400'
                          : 'bg-blue-50 text-blue-700 border border-blue-200'
                      }`}
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* CTA Section */}
      <section className={`py-20 px-6 ${
        isDarkMode ? 'bg-gray-800' : 'bg-gradient-to-br from-blue-50 to-purple-50'
      }`}>
        <div className="max-w-4xl mx-auto text-center">
          <h2 className={`text-3xl md:text-5xl font-bold mb-6 ${
            isDarkMode ? 'text-white' : 'text-gray-900'
          }`}>
            Quer ser nosso próximo caso de sucesso?
          </h2>
          <p className={`text-xl mb-8 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
            Entre em contacto connosco e vamos juntos transformar o seu projecto em realidade
          </p>
          <button 
          onClick={() => setIsQuoteModalOpen(true)}
          className="px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-full font-semibold hover:shadow-2xl hover:shadow-blue-500/50 transition-all">
            Iniciar Projeto
          </button>
        </div>
      </section>

      <Footer isDarkMode={isDarkMode} />

      <style jsx>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }

        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>
              <QuoteModal
        isOpen={isQuoteModalOpen}
        onClose={() => setIsQuoteModalOpen(false)}
        isDarkMode={isDarkMode}
        preSelectedService={preSelectedService}  
      />
    </div>
  );
}